/**
 * Wizard Steps Constants
 * Single source of truth for the 7-step eligibility assessment flow
 */

export const WIZARD_STEPS = [
  "Company",
  "BusinessMetrics",
  "LocationOps",
  "GrantHistory",
  "Project",
  "Compliance",
  "Review",
];

export const WIZARD_STEP_TITLES = {
  Company: "Company Basics",
  BusinessMetrics: "Business Metrics",
  LocationOps: "Location & Ops",
  GrantHistory: "Grant History",
  Project: "Project",
  Compliance: "Compliance",
  Review: "Review",
};

/**
 * Calculate completion progress based on completed pages
 * @param {number} currentStep - Current step index (1-7 for SG, 1-4 for US)
 * @param {boolean} isSubmitted - Whether the form has been submitted
 * @param {number} totalSteps - Total number of steps (7 for SG, 4 for US)
 * @returns {number} Progress percentage (0-100)
 */
export function getProgress(currentStep, isSubmitted = false, totalSteps = 7) {
  if (isSubmitted) {
    return 100; // Force 100% on successful submission
  }
  
  const completedPages = Math.max(0, currentStep - 1); // Pages completed = currentStep - 1
  const pct = Math.round((completedPages / totalSteps) * 100);
  return Math.min(100, Math.max(0, pct)); // Clamp to 0-100
}


/**
 * Whether the stepper lets the person jump to `target`: completed steps, the current one, and
 * the first step after the furthest one completed (the US wizard's canJumpTo).
 */
export function canJumpToStep(target, current, completed = []) {
  const maxCompleted = completed.length > 0 ? Math.max(...completed) : 0;
  return completed.includes(target) || target === current || target <= maxCompleted + 1;
}
